import React from "react";
import { Helmet } from "react-helmet";

const Shippingpolicy = () => {
  return (
    <>
      <Helmet>
        <title>Shipping Policy - eYantra</title>
      </Helmet>

      <div class="container my-5">
        <h1 class="text-center texteYantra">Shipping Policy</h1>
        <p class="text-center">
          Please read our shipping policy carefully for information on delivery
          charges, timelines, and services.
        </p>

        <h2>What are the delivery charges?</h2>
        <p>
          Delivery charges vary depending on the seller. Some products may incur
          delivery charges to cover logistics costs. Refer to the order summary
          for individual product delivery charges. Higher-value products are
          usually delivered free of charge.
        </p>

        <h2>
          Why does the delivery date not match the delivery timeline of ABC
          business days?
        </h2>
        <p>
          The delivery date might differ due to holidays or non-working days for
          the courier partner or seller. In such cases, we add an extra day to
          the estimated delivery date. Sundays are non-working days for some
          sellers and courier partners, resulting in an additional day added to
          the delivery estimate.
        </p>

        <h2>What is the estimated delivery time?</h2>
        <p>
          The estimated delivery time is mentioned on the product page. The
          seller will process and ship the product on time, excluding Sundays or
          public holidays. The delivery time is primarily based on the seller's
          location and the customer's delivery address.
        </p>

        <h2>
          Are there any additional (hidden) charges on the items listed on
          eYantra website?
        </h2>
        <p>
          There are no hidden charges when you purchase from eYantra. The price
          displayed for each product is the final price you will pay. Any
          delivery charges, if applicable, will be clearly mentioned based on
          the seller's shipping policy.
        </p>

        <h2>Why does each seller show different delivery time?</h2>
        <p>
          The delivery date is determined by several factors, including the
          seller's location, product availability, courier partner's delivery
          time, and the final destination. You can check the most accurate
          delivery date by entering your pin code on the product page. During
          checkout, the estimated delivery date will be based on the pin code
          provided in your delivery address.
        </p>

        <h2>Why can't some sellers ship to my location/area?</h2>
        <p>
          Whether a seller can ship to your location is entirely at their
          discretion. It depends on the availability of reliable courier
          partners in your area or any legal restrictions on shipping specific
          products. If a seller cannot ship to your location, we encourage you
          to check with other sellers on the platform.
        </p>

        <h2>Why is there no COD option for my location?</h2>
        <p>
          Cash on Delivery (COD) is available based on the courier partner's
          ability to accept cash payments in your location. Please check whether
          COD is available in your area by entering your pin code on the product
          page.
        </p>

        <h2>Does eYantra deliver internationally?</h2>
        <p>
          Currently, eYantra does not deliver internationally. You can order
          products from eYantra from any part of the world, but ensure that the
          delivery address is located within India. Payments can be made via
          debit/credit cards on our website.
        </p>
      </div>
    </>
  );
};

export default Shippingpolicy;
